import Button from '../../button/block';
import LicencieLogo from '../../assets/licencie.png';
import style from './style.module.scss';
import clsx from 'clsx';

export const DealTile = ({ deal, isEmailVerified }) => {
    const lockTile =
        !deal.hasLevel || !deal.hasALicense || !deal.isSponsor || (deal.isUserLoggedIn && !isEmailVerified);
    const Wrapper = deal.expired || lockTile ? 'div' : 'a';

    const getButtonText = () => {
        if (lockTile && !deal.hasALicense) return 'RÉSERVÉ AUX LICENCIÉS';
        if (lockTile && !deal.hasLevel) return "VOUS N'AVEZ PAS LE NIVEAU";
        if (lockTile && deal.isUserLoggedIn && !isEmailVerified) return "VALIDE TON COMPTE POUR DÉCOUVRIR L'AVANTAGE";
        return 'VOIR LA PROMO';
    };

    return (
        <div className={style.block}>
            <div className={clsx(style.container, lockTile && style.lockTile)}>
                {lockTile && <div className={style.lockTileFilter}></div>}
                <div className={style.imgContainer}>
                    {deal.mini_picture?.url && <img src={deal.mini_picture.url} alt="Miniature du bon plan" />}
                </div>

                <div className={style.content}>
                    <div className={style.licencieContainer}>
                        <div className={style.licencieText}>
                            <span>AVANTAGE</span>
                            <span>LICENCIÉ</span>
                        </div>
                        <div className={style.logoContainer}>
                            <img src={LicencieLogo} className={style.logoLicencie} alt="Logo licencié" />
                        </div>
                    </div>
                    <div className={style.title}>{deal.tile_title || '\u00A0'}</div>

                    {deal.tile_text && <p className={style.excerpt}>{deal.tile_text}</p>}

                    <Button
                        classNames={style.button}
                        text={getButtonText()}
                        link={deal.link}
                        aspect="contained"
                        position="center"
                        backgroundContained={style.green}
                        colorContained={style.blue}
                        inspector={false}
                        Wrapper={Wrapper}
                    />
                </div>
            </div>

            {lockTile && (
                <div className={style.levelOverlay}>
                    <div className={style.info}>
                        {!deal.hasLevel && (
                            <>
                                <div className={style.levelLabelContainer}>
                                    <span>NIVEAU</span>
                                    <span>{deal.requiredRankName}</span>
                                </div>
                                <div className={style.logoContainer}>
                                    <img src={deal.requiredRankImage} alt="Logo du niveau requis" />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
